import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTE_PATHS } from '@constants';
import { PRODUCT_ECOMMERCE_STATUS } from '@enums';
import { useStore } from '@hooks';
import { Loader } from '@ui';
import { observer } from 'mobx-react';

const CampaignsLoadingPage = observer(() => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const store = useStore();
    const { isManualStoreWithNoCampaigns, isManualWithSyncInProgressOrFailed } = store.accountsStore;

    useEffect(() => {
        const handleNavigation = async () => {
            if (isManualWithSyncInProgressOrFailed) {
                navigate(ROUTE_PATHS.CAMPAIGNS);
            } else if (isManualStoreWithNoCampaigns) {
                const { getProducts } = store.productsStore;

                await getProducts();
                const filteredProducts = store.productsStore.products.filter(
                    (product) => product.ecommerceStatus !== PRODUCT_ECOMMERCE_STATUS.DEMO
                );
                const hasProducts = store.productsStore.meta?.total
                    ? store.productsStore.meta.total > 0
                    : !!filteredProducts.length;

                if (hasProducts) {
                    navigate(ROUTE_PATHS.CAMPAIGNS_CREATE_STEP_1);
                } else {
                    navigate(ROUTE_PATHS.CAMPAIGNS_PRE_WIZARD);
                }
            } else if (searchParams.get('step') !== 'false') {
                navigate(ROUTE_PATHS.CAMPAIGNS_CREATE_STEP_1);
            } else {
                navigate(ROUTE_PATHS.CAMPAIGNS);
            }
        };

        handleNavigation();
    }, [isManualWithSyncInProgressOrFailed, isManualStoreWithNoCampaigns, navigate, store, searchParams]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <Loader size='120px' />
        </div>
    );
});

export default CampaignsLoadingPage;
